
           <div class="d-flex align-items-center  px-3" style="height:67px;" [ngStyle]="{'border-top': '.5px solid ' + stylePathPrice?.card_line}">
             <img
                src="../../../../../assets/icons/search-result/BLICKOIS-01.svg"
                width="28px"
                height="28px"
                alt=""
                class="mr-1 ml-2"
              />
              <div>
                <p class="ml-1 mb-0 rubik-regular-12pt" style="line-height: 1;color: black">
                 Sumás
                </p>
                 <p class="ml-1 mb-0 rubik-regular-12pt" style="font-weight: 500; color: #fec039">
                  {{ blickoins  | number : "1.2-2" }} BKS
                </p>
              </div>
          </div>
  